import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await api.get('/auth/me');
        setUser(response.data);
      } catch (error) {
        localStorage.removeItem('token');
        setUser(null);
      }
    }
    setLoading(false);
  };

  const login = async (username, password) => {
    console.log('Login attempt:', { username, password });
    try {
      console.log('Calling API at:', api.defaults.baseURL + '/auth/login');
      const response = await api.post('/auth/login', { username, password });
      console.log('Login response:', response.data);
      const { access_token, role, mr_name, mr_emp_code, mr_hq } = response.data;
      localStorage.setItem('token', access_token);
      const userData = { username, role, mr_name, mr_emp_code, mr_hq };
      setUser(userData);
      return { success: true, user: userData };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response);
      const statusCode = error.response?.status;
      const backendMessage = error.response?.data?.detail;
      const invalidCredentials =
        statusCode === 401 ||
        (typeof backendMessage === 'string' && backendMessage.toLowerCase().includes('invalid username or password'));

      const message = invalidCredentials
        ? 'Check password or invalid entry'
        : (backendMessage || 'Login failed');
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    logout,
    checkAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
